import React from 'react'
import './basic-dropdown.css'
import Select from 'react-select'

const BasicDropdown = ({
  placeholder,
  options,
  disabled,
  className,
  multi,
  style,
  noMarginBottom,
  defaultValue
}) => {

  const classes =
  `text-sm ${noMarginBottom ? '' : 'mb-4'} ${className}`

  const styles = {
    control: () => ({
      borderColor: '#ddd',
    }),
    ...style
  }

  return (
    <Select
      isMulti={multi}
      options={options}
      className={classes}
      isDisabled={disabled}
      placeholder={placeholder}
      style={styles}
      defaultValue={defaultValue}
    />
  )
}

export { BasicDropdown }